import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import ActionComment from './action-comment'
import { getContribution } from '../../../../../stores/discussion/discussion.selectors'
import {
  getAssessmentFileConclusionState,
  getContributorsCount,
  getAssessmentFileClosedState
} from '../../../../../stores/assessment-file/assessment-file.selectors'
import {
  markAsConclusion,
  unmarkAsConclusion,
  submitContributionReply
} from '../../../../../stores/discussion/discussion.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import {
  getWorksResult,
  getWork
} from '../../../../../stores/works/works.selectors'

const mapStateToProps = (state, { id, match }) => {
  const action = getContribution(state, id)
  const isAFConcluded = getAssessmentFileConclusionState(
    state,
    match.params.assessmentFileId
  )
  const assessmentFileWorks = getWorksResult(state)
  const workId =
    action.action_object &&
    action.action_object.works &&
    action.action_object.works[0] &&
    action.action_object.works[0].id
  const workRef = getWork(state, workId)
  const isAFClosed = getAssessmentFileClosedState(state)
  return {
    id,
    assessmentFileId: match.params.assessmentFileId,
    contributionId: action.action_object.id,
    name: action.originator.full_name,
    localAuthority:
      action.originator.la_manager_type &&
      action.originator.la_manager_type.school_organisation &&
      action.originator.la_manager_type.school_organisation.title,
    isLocalAuthorityManager:
      action.originator.la_manager_type &&
      action.originator.la_manager_type.school_organisation &&
      action.originator.la_manager_type.school_organisation.local_authority,
    avatar: action.originator.avatar,
    content: action.action_object.content,
    isConclusion: action.action_object.conclusion,
    concludedBy:
      action.action_object &&
      action.action_object.marked_as_conclusion_by &&
      action.action_object.marked_as_conclusion_by.full_name,
    isAFConcluded: isAFConcluded,
    contributorsCount: getContributorsCount(
      state,
      match.params.assessmentFileId
    ),
    timestamp: action.action_object && action.action_object.created_at,
    attachment:
      action.action_object &&
      action.action_object.attachment &&
      action.action_object.attachment.file_url,
    attachmentName:
      action.action_object &&
      action.action_object.attachment &&
      action.action_object.attachment.file_url &&
      unescape(action.action_object.attachment.file_url.split('/').pop(-1)),
    canDelete:
      action.action_object &&
      action.action_object.policy &&
      action.action_object.policy.can_delete,
    edited: action.action_object && action.action_object.edited_at,
    workId: workId,
    assessmentFileWorks: assessmentFileWorks,
    workRef: workRef,
    isAFClosed,
    replies: action.action_object && action.action_object.replies
  }
}

const mapDispatchToProps = dispatch => ({
  onMarkedAsConclusion: (id, actionId) =>
    dispatch(markAsConclusion(id, actionId)).catch(errorHandler),
  onUnmarkedAsConclusion: (id, actionId) =>
    dispatch(unmarkAsConclusion(id, actionId)).catch(errorHandler),
  onReply: (assessmentFileId, parentId, contribution, id) => {
    return dispatch(
      submitContributionReply(
        assessmentFileId,
        parentId,
        {
          content: contribution
        },
        id
      )
    ).catch(errorHandler)
  }
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ActionComment)
)
